import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ActUserComponent } from '@features/act-user/act-user-component/act-user.component';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { isloaded } from '@core/guards/is-loaded.guard';
import { dashboardTypeGuard } from '@core/guards/dashboard-type.guard';
import { redirectToDefaultPage } from '@core/guards/redirect-to-default-page.guard';
import { roleGuard } from '@core/guards/permissions-check.guard';
import { Role } from '@features/user/store/user.interface';
import { RoutingURL } from '@core/components/main-nav/main-nav.state';
import { NotFoundComponent } from '@core/components/not-found/not-found.component';
import { IdleIframeComponent } from '@core/components/idle-iframe/idle-iframe.component';

const routes: Routes = [
  {
    path: 'Iframe-organizations',
    title: 'List of organizations',
    canLoad: [roleGuard(Role.SysAdmin, Role.DepartmentAdmin)],
    loadChildren: () =>
      import('./features/organizations/organizations.module').then(
        (m) => m.OrganizationsModule,
      ),
  },
  {
    path: 'Iframe-meters',
    title: 'List of meters',
    canLoad: [roleGuard(Role.SysAdmin, Role.DepartmentAdmin, Role.DeviceAdmin)],
    loadChildren: () =>
      import('./features/meters/meters.module').then((m) => m.MetersModule),
  },
  {
    path: 'Iframe-meter-groups',
    title: 'List of meters group',
    canLoad: [roleGuard(Role.SysAdmin, Role.DepartmentAdmin, Role.DeviceAdmin)],
    loadChildren: () =>
      import('./features/meter-group/meter-group.module').then(
        (m) => m.MeterGroupsModule,
      ),
  },
  {
    path: 'Iframe-users',
    title: 'List of users',
    canLoad: [
      roleGuard(Role.SysAdmin, Role.DepartmentAdmin, Role.PermissionsAdmin),
    ],
    loadChildren: () =>
      import('./features/user/user.module').then((m) => m.UserModule),
  },
  {
    path: 'Iframe-departments',
    title: 'List of departments',
    canLoad: [roleGuard(Role.SysAdmin)],
    loadChildren: () =>
      import('./features/departments/departments.module').then(
        (m) => m.DepartmentsModule,
      ),
  },
  {
    path: 'Iframe-reports',
    title: 'List of reports',
    loadChildren: () =>
      import('./features/reports/reports.module').then((m) => m.ReportsModule),
  },
  {
    path: 'Iframe-import-history',
    title: 'List of imported files',
    loadChildren: () =>
      import('./features/import-history/import-history.module').then(
        (m) => m.ImportHistoryModule,
      ),
  },
  {
    path: 'Iframe-dashboard/:dashboardType',
    title: 'ExpertPower - Dashboard',
    canActivate: [dashboardTypeGuard],
    loadChildren: () =>
      import('./features/dashboard/dashboard.module').then(
        (m) => m.DashboardModule,
      ),
  },
  {
    path: RoutingURL.notFound,
    title: 'ExpertPower - 404',
    component: IdleIframeComponent,
  },
  { path: '**', redirectTo: '404' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // Don't perform initial navigation in iframes or popups
      initialNavigation: 'enabledNonBlocking',
      // !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
      //   ? 'enabledNonBlocking'
      //   : 'disabled', // Set to enabledBlocking to use Angular Universal
    }),
    StoreRouterConnectingModule.forRoot(),
  ],
  exports: [RouterModule],
})
export class AppRoutingIframeModule {}
